import {ModelData} from "./model/modelData";

export const availableModels: { [modelKey: string]: { [modelYear: string]: ModelData } } = {
  "smart #1": {
    "2022": {
      "parts": [
        "GeelyCoolant",
        "WindshieldFluid",
        "BrakeFluid",
        "TyreRepairEmulsion",
        "HVLithiumIonBatteryPack",
        "LeadAcidBattery",
        "NickelMetalHybrideBattery",
        "SirenBackupBattery",
        "AirbagInflatorDriver",
        "AirbagInflatorDMF5000",
        "AirbagInflatorDNB5000",
        "CABInflatorAssembly",
        "MicroGasGenerator",
        "MicroGasGeneratorCNGTMS2",
        "GearboxLubricantDEXRON",
        "GearboxLubricantIDEMITSU",
        "FireExtinguisher",
        "SensorTirePressure",
      ], "scips": [
        "245321034",
        "236503760",
        "235770784",
        "245356211",
        "245356172",
        "245321034-four-wheel",
      ]
    }
  }, "smart #3": {
    "2023": {
      "parts": [
        "GeelyCoolant",
        "WindshieldFluid",
        "BrakeFluid",
        "TyreRepairEmulsion",
        "HVLithiumIonBatteryPack",
        "LeadAcidBattery",
        "NickelMetalHybrideBattery",
        "SirenBackupBattery",
        "AirbagInflatorDriver",
        "AirbagInflatorDMF5000",
        "AirbagInflatorDNB5000",
        "CABInflatorAssembly",
        "MicroGasGenerator",
        "MicroGasGeneratorCNGTMS2",
        "GearboxLubricantDEXRON",
        "GearboxLubricantIDEMITSU",
        "FireExtinguisher",
        "SensorTirePressure",
        "ACCompressorOil"
      ], "scips": [
        "245321034",
        "236503760",
        "235770784",
        "245356211",
        "245356172",
        "245321034-four-wheel",
      ]
    }
  },"smart #5": {
    "2025": {
      "parts": [
        "TRANSMISSION OIL",
        "TIRE REPAIRED EMULSION",
        "STORAGE BATTERY",
        "SENSOR_TIRE PRESSURE",
        "SEAT BELT_SECOND ROW SIDE",
        "SEAT BELT_FIRST ROW",
        "MODULE_TELEMATIC NODE",
        "FIRE EXTINGUISHER",
        "COOLANT_1.5L_4L",
        "CLEANSER_GLASS",
        "BRAKE FLUID_1L",
        "BATTERY_HIGH VOLTAGE_NBE761",
        "BATTERY_HIGH VOLTAGE_NBE1005",
        "AIR CURTAIN",
        "AIR BAG_PASSENGER",
        "AIR BAG_FRONT SIDE",
        "AIR BAG_FAR SIDE",
        "AIR BAG_DRIVER",
        "AC COMPRESSOR OIL_800V",
        "AC COMPRESSOR OIL_400V",
      ], "scips": [
        "245321034",
        "236503760",
        "235770784",
        "245356211",
        "245356172",
        "245321034-four-wheel",
      ]
    }
  }
}
